import { createSelector } from 'reselect';
import { AnyStateWithRestrictions } from './types';

export const getRestrictionsState = (state: AnyStateWithRestrictions) => state.restrictions;

export const getRestrictions = createSelector(
	getRestrictionsState,
	restrictionsState => restrictionsState?.restrictions
);

export const hasRestrictions = createSelector(
	getRestrictions,
	restrictions => !!restrictions && restrictions.length > 0
);

export const getRestrictionsLoading = createSelector(
	getRestrictionsState,
	restrictionsState => restrictionsState?.loading
);

export const getRestrictionsAccepted = createSelector(
	getRestrictionsState,
	restrictionsState => restrictionsState?.accepted
);
